
import React, {useState, useEffect} from 'react';
import { useFormik } from 'formik';
import * as Yup from "yup";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import MaskedInput from 'react-text-mask';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';

const autoCorrectedDatePipe = createAutoCorrectedDatePipe('mm/dd/yyyy');


const BfFormstep22 = ({lang, setLang, nextStep, backStep, updateFormData, formData, driverIndexToEdit, driverIndexToDisplay, setDriverIndexToEdit, driverDisplayIndex }) => {
  const handleNameInputChange = (e, fieldName) => {
    // Extract the input value
    const inputValue = e.target.value;
  
    // Filter to allow only letters, hyphen, commas, periods, apostrophes, ñ, Spanish vowels with tildes, and |
    const extendedValue = inputValue.replace(/[^a-zA-Z-,.ñáéíóúüÁÉÍÓÚÜ| ']/g, '');
  
    // Update the formik value with the filtered value
    formik.setFieldValue(fieldName, extendedValue);
  }
// state variable that checks if license is from mexico or not, boolean
const [isMexicanLicense, setIsMexicanLicense] = useState(true);
  const setIndexToNull = () => {
    setDriverIndexToEdit(null);
  }
  const handleLetterInputChange = (e, fieldName) => {
    // Extract the input value
    const inputValue = e.target.value;
  
    // Filter o t non-letter characters
    const lettersOnlyValue = inputValue.replace(/[^a-zA-Z]/g, '');
  
    // Update the formik value with the filtered value
    formik.setFieldValue(fieldName, lettersOnlyValue);
  }
  const defaultDriverValues = {
    lastName: '',
    firstName: '',
    middleName: '',
    dob: null,
    licenseNumber: '',
    issuedStateMx: '',
    expirationDate: null,
    is_foreigner: 'NO',
    country_origin: '',
  };
  const createValidationSchema = (isMexicanLicense, messages) => {
  return Yup.object().shape({
    lastName: Yup.string()
      .min(2, messages.min)
      .required(messages.required),
    firstName: Yup.string()
      .min(2, messages.min)
      .required(messages.required),
    middleName: Yup.string(),
    dob: Yup.string()
      .required(messages.required),
    licenseNumber: isMexicanLicense
      //minumum o 5 max of 13
      ? Yup.string().min(5, messages.fiveto13).max(13, messages.fiveto13)
      //4 to 20
      : Yup.string().min(4, messages.fourto20).max(20, messages.fourto20),
    issuedStateMx: isMexicanLicense 
      ? Yup.string().required(messages.required) 
      : Yup.string().min(2, messages.min),
    expirationDate: Yup.string()
      .required(messages.required),
    country_origin: Yup.string()
  });
};
  let initialvalues = { ...defaultDriverValues};

  const messages = {
    min: lang === 'eng' ? "Please enter at least 2 characters" : "Por favor, ingrese al menos 2 caracteres",
    required: lang === 'eng' ? "This field is required." : "Este campo es obligatorio.",
    fiveto13: lang === 'eng' ? "Please enter a value between 5 and 13 characters long." : "Por favor, ingrese un valor entre 5 y 13 caracteres de largo.",
    fourto20: lang === 'eng' ? "Please enter a value between 4 and 20 characters long." : "Por favor, ingrese un valor entre 4 y 20 caracteres de largo.",
  };
  
  const validationschema = createValidationSchema(isMexicanLicense, messages);

  
  const handleAlphanumInputChange = (e, fieldName) => {
    // Extract the input value
    const inputValue = e.target.value;
  
    // Filter to allow only letters, numbers, and hyphen
    const alphanumValue = inputValue.replace(/[^a-zA-Z0-9-]/g, '');
  
    // Update the formik value with the filtered value
    formik.setFieldValue(fieldName, alphanumValue);
  }

  // Set initial values if driverIndexToEdit is not null
  
  if(formData && driverIndexToEdit !== null) {
 
    initialvalues = {
      lastName: formData.step22[`drivers[${driverIndexToEdit}]last name`] || '',
      firstName: formData.step22[`drivers[${driverIndexToEdit}]first name`] || '',
      middleName: formData.step22[`drivers[${driverIndexToEdit}]middle name`] || '',
      dob: new Date(formData.step22[`drivers[${driverIndexToEdit}]dob`]) || new Date(),
      licenseNumber: formData.step22[`drivers[${driverIndexToEdit}]license no`] || '',
      issuedStateMx: formData.step22[`drivers[${driverIndexToEdit}]issued state mx`] || '',
      expirationDate: new Date(formData.step22[`drivers[${driverIndexToEdit}]expiration date`]) || new Date(),
      is_foreigner: formData.step22[`drivers[${driverIndexToEdit}]is foreigner`] || '',
      country_origin: formData.step22[`drivers[${driverIndexToEdit}]country origin`] || '',
    };
  }
  const formik = useFormik({

    initialValues: initialvalues,
    validationSchema: validationschema,
    onSubmit: (values) => {
      //if isforeigner is yes, then issued_state_mx is blank
      if(values.is_foreigner === "YES") {
        values.issuedStateMx = "";
      }
      updateFormData(values);
      nextStep();
    },

  });

//useEffect to console.log the formik.values
 useEffect(() => {
     //if isforeigner is yes, then setismexicanlicense to false
      if(formik.values.is_foreigner === "YES") {
        setIsMexicanLicense(false);
      } 
}, [formik.values]);
 
return (

    <>

      <>
        <header className="c-site-header">
          <a className="c-site-header__skip js-site-header-skip" href="#main">
            Skip to main content
          </a>
          <div className="o-wrapper">
            <a
              className="c-site-header__logo-link"
              href="./"
              aria-label="Go to home page"
            >
              <img
                className="c-site-header__logo"
                src="images/components/site-header/logo-blf-specialty.svg"
                alt="Bluefire Specialty Logo"
                width={100}
                height={34}
              />
            </a>
            <h1 className="c-site-header__title">
          <span className="o-icon">
            <svg aria-hidden="true" focusable="false" role="img">
              <use href="images/icons/icons.svg#icon-drivers" />
            </svg>
          </span>
          {lang === 'eng' ? 'Drivers Information' : 'Información de conductores'}

        </h1>
            <div className="c-site-header__controls c-header-controls">
            <button 
    className="c-header-controls__language" 
    onClick={() => setLang(lang === 'eng' ? 'spa' : 'eng')}  // Toggle the language
  >
    <span className="o-icon c-header-controls__icon">
      <svg aria-hidden="true" focusable="false" role="img">
        <use href="images/icons/icons.svg#icon-language" />
      </svg>
    </span>
    <span className="u-hidden-visually">
      {lang === 'eng' ? 'Switch to Spanish' : 'Switch to English'}
    </span>
    <span className="c-header-controls__text">
      {lang === 'eng' ? 'Español' : 'English'}
    </span>
  </button>
            </div>
          </div>
        </header>
        <main className="c-main-content">
          <div className="c-section">
            <div className="o-wrapper o-wrapper--small">
              <h1 className="c-section__title">
                <span className="o-icon">
                  <svg aria-hidden="true" focusable="false" role="img">
                    <use href="images/icons/icons.svg#icon-drivers" />
                  </svg>
                </span>
                {lang === 'eng' ? 'Drivers Information' : 'Información de conductores'}
              </h1>
              <div className="c-section__content">
                <div className="c-steps">
                  <ul className="o-list-bare c-steps__list">
                    <li className="o-list-bare__item c-steps__item c-steps__item--100 c-steps__step--completed">
                      <div className="c-steps__step">
                      <div className="c-steps__text">{lang === 'eng' ? 'Applicant' : 'Solicitante'}</div>
                        <div className="c-steps__circle" />
                      </div>
                    </li>
                    <li className="o-list-bare__item c-steps__item c-steps__item--50 c-steps__step--active">
                      <div className="c-steps__step c-steps__step">
                      <div className="c-steps__text">{lang === 'eng' ? 'Drivers' : 'Conductores'} </div>
                        <div className="c-steps__circle" />
                      </div>
                    </li>
                    <li className="o-list-bare__item c-steps__item">
                      <div className="c-steps__step c-steps__step">
                      <div className="c-steps__text">{lang === 'eng' ? 'Vehicles' : 'Vehículos'}</div>
                        <div className="c-steps__circle" />
                      </div>
                    </li>
                        <li className="o-list-bare__item c-steps__item">
                <div className="c-steps__step">
                  <div className="c-steps__text">{lang === 'eng' ? 'Documents' : 'Documentos' }</div>
                  <div className="c-steps__circle" />
                </div>
              </li>
                    <li className="o-list-bare__item c-steps__item">
                      <div className="c-steps__step">
                      <div className="c-steps__text">{lang === 'eng' ? 'Finish' : 'Finalizar' }</div>                  <div className="c-steps__circle" />
                   
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="c-content">
                  <div className="c-adding">
                    <h2 className="c-adding__title">Adding New Vehicle</h2>
                    <div className="c-adding__text">
                      <p>
                        You can add up to 45 drivers. If you need more, please contact
                        us at <a href="tel:888-851-5070">888-851-5070</a>
                      </p>
                      <p>Click here to add Vehicles. </p>
                    </div>
                    <div className="c-adding__control">
                      <button className="c-button c-button--blue" type="button">
                        <span className="o-icon">
                          <svg aria-hidden="true" focusable="false" role="img">
                            <use href="images/icons/icons.svg#icon-plus" />
                          </svg>
                        </span>
                        Add Vehicles
                      </button>
                    </div>
                    <div className="c-adding__image">
                      <img
                        src="images/components/ima-add.svg"
                        aria-hidden="true"
                        width={240}
                        height={167}
                      />
                    </div>
                  </div>
                  <div className="c-quote__controls">
                    <button
                      className="c-quote__control c-quote__control--previous c-button c-button--linear-indingo"
                      type="button"
                    >
                                      {lang === 'eng' ? 'Previous' : 'Atrás'}

                    </button>
                    <button
                      className="c-quote__control c-quote__control--submit c-button c-button--disabled"
                      type="button"

                    >
                      {lang === 'eng' ? 'Continue' : 'Continuar'}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
        <div
          className="c-modal-quote is-open"
          role="dialog"
          aria-modal="true"
          aria-label="Get a Quick Quote"
        >
          <div className="c-modal-quote__overlay" />
          <div className="o-wrapper o-wrapper">
            <div className="c-modal-quote__content">
              <div className="c-modal-quote__title">
                <span className="o-icon">
                  <svg aria-hidden="true" focusable="false" role="img">
                    <use href="images/icons/icons.svg#icon-plus" />
                  </svg>
                </span>
                <h2>
                {lang === 'eng' ? 'Add Driver' : 'Agregar conductor'}
                </h2>
              </div>
              <div className="c-quote">



                <form onSubmit={formik.handleSubmit} className="c-quote__form js-form" noValidate>

                  <h2 className="c-quote__title">
                    
                    {lang === 'eng' ? 'Driver No.' : 'Conductor No.'} {driverIndexToEdit !== null ? driverIndexToDisplay : driverDisplayIndex}
                  </h2>

                  {/* Last Name */}
                  <div className={`c-quote__item c-quote__item--d40 c-quote__item--m100 ${formik.touched.lastName && formik.errors.lastName ? 'c-quote-error' : ''}`}>
                    <label className="c-quote__label" htmlFor="lastName">
                      {lang === 'eng' ? 'Last Name' : 'Apellido'}
                    </label>
                    <input
                      className={`c-quote__input only-letters ${formik.touched.lastName && formik.errors.lastName ? 'js-form-error' : ''}`}
                      id="lastName"
                      type="text"
                      name="lastName"
                      maxLength={50}
                      minLength={2}
                      required
                      aria-required="true"
                      aria-invalid={formik.touched.lastName && formik.errors.lastName ? 'true' : 'false'}
                      onChange={e => handleNameInputChange(e, "lastName")}
                      onBlur={formik.handleBlur}
                      value={formik.values.lastName}
                    />
                    {formik.touched.lastName && formik.errors.lastName ? (
                      <label id="lastName-error" className="js-form-error" htmlFor="lastName">
                        {formik.errors.lastName}
                      </label>
                    ) : null}
                  </div>

                  {/* First Name */}
                  <div className={`c-quote__item c-quote__item--d40 c-quote__item--m100 ${formik.touched.firstName && formik.errors.firstName ? 'c-quote-error' : ''}`}>
                    <label className="c-quote__label" htmlFor="firstName">
                      {lang === 'eng' ? 'First Name' : 'Nombre'}
                    </label>
                    <input
                      className={`c-quote__input only-letters ${formik.touched.firstName && formik.errors.firstName ? 'js-form-error' : ''}`}
                      id="firstName"
                      type="text"
                      name="firstName"
                      maxLength={50}
                      required
                      //check if ismexicanLicence and disable the field if not 
                  
                      aria-required="true"
                      aria-invalid={formik.touched.firstName && formik.errors.firstName ? 'true' : 'false'}
                      onChange={e => handleNameInputChange(e, "firstName")}
                      onBlur={formik.handleBlur}
                      value={formik.values.firstName}
                    />
                    {formik.touched.firstName && formik.errors.firstName ? (
                      <label id="firstName-error" className="js-form-error" htmlFor="firstName">
                        {formik.errors.firstName}
                      </label>
                    ) : null}
                  </div>


                  {/* Middle Name */}
                  <div className={`c-quote__item c-quote__item--d25 c-quote__item--m50 ${formik.touched.middleName && formik.errors.middleName ? 'c-quote-error' : ''}`}>
                    <label className="c-quote__label" htmlFor="middleName">
                      {lang === 'eng' ? 'Middle Name' : 'Segundo Nombre'}
                    </label>
                    <input
                      className={`c-quote__input ${formik.touched.middleName && formik.errors.middleName ? 'js-form-error' : ''}`}
                      id="middleName"
                      type="text"
                      name="middleName"
                      maxLength={1}
                      required
                      aria-required="true"
                      aria-invalid={formik.touched.middleName && formik.errors.middleName ? 'true' : 'false'}
                      onChange={e => handleLetterInputChange(e, "middleName")}
                      onBlur={formik.handleBlur}
                      value={formik.values.middleName}
                    />
                    {formik.touched.middleName && formik.errors.middleName ? (
                      <label id="middleName-error" className="js-form-error" htmlFor="middleName">
                        {formik.errors.middleName}
                      </label>
                    ) : null}
                  </div>

                  {/* Date of Birth */}
                  <div className={`c-quote__item c-quote__item--50 c-quote__item--m100  ${formik.touched.dob && formik.errors.dob ? 'c-quote-error' : ''}`}>
  <label className="c-quote__label"  htmlFor="dob">
    {lang === 'eng' ? 'Date of Birth‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ' : 'Fecha de Nacimiento‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ '}
  </label>
  <DatePicker
   isClearable
    placeholderText={lang === 'eng' ? 'MM/DD/YYYY' : 'MM/DD/AAAA'}
    className={`c-quote__input ${formik.values.dob ? '' : 'c-quote__input--dob'} ${formik.touched.dob && formik.errors.dob ? 'js-form-error' : ''}`}
    id="dob"
    name="dob"
    showMonthDropdown
    showYearDropdown
    dropdownMode="select"
    maxDate={new Date(new Date().getFullYear() - 18, new Date().getMonth(), new Date().getDate())}
    selected={formik.values.dob}
    onChange={(date) => formik.setFieldValue("dob", date)}
    dateFormat="MM/dd/yyyy"
    customInput={
      <MaskedInput
        mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
        pipe={autoCorrectedDatePipe}
        keepCharPositions
      />
    }
  />
  {formik.touched.dob && formik.errors.dob ? (
    <label id="dob-error" className="js-form-error" htmlFor="dob">
      {formik.errors.dob}
    </label>
  ) : null}
</div>




                  <div className="c-quote__item c-quote__item--empty"></div>
                  <h3 className="c-quote__title-content">{lang === 'eng'? "Mexican Driver License" : "Licencia de Conducir Mexicana"}</h3>
                  <div className="c-quote__item c-quote__item--empty" />  
                  {/* License Number */}
                  <div className={`c-quote__item c-quote__item--50 c-quote__item--m100 ${formik.touched.licenseNumber && formik.errors.licenseNumber ? 'c-quote-error' : ''}`}>
                    <label className="c-quote__label" htmlFor="licenseNumber">
                      {lang === 'eng' ? 'Lic No.' : 'No. de Licencia'}
                    </label>
                    <input
                      className={`c-quote__input ${formik.touched.licenseNumber && formik.errors.licenseNumber ? 'js-form-error' : ''}`}
                      id="licenseNumber"
                      type="text"
                      name="licenseNumber"
                      maxLength={isMexicanLicense ? 13 : 20}

                      required
                      aria-required="true"
                      aria-invalid={formik.touched.licenseNumber && formik.errors.licenseNumber ? 'true' : 'false'}
                      onChange={e => handleAlphanumInputChange(e, "licenseNumber")}
                      onBlur={formik.handleBlur}
                      value={formik.values.licenseNumber}
                    />
                    {formik.touched.licenseNumber && formik.errors.licenseNumber ? (
                      <label id="licenseNumber-error" className="js-form-error" htmlFor="licenseNumber">
                        {formik.errors.licenseNumber}
                      </label>
                    ) : null}
                  </div>

                  <div className={`c-quote__item c-quote__item--50 c-quote__item--m100 ${formik.touched.issuedStateMx && formik.errors.issuedStateMx ? 'c-quote-error' : ''}`}>
  <label className="c-quote__label" htmlFor="issuedStateMx">
    {lang === 'eng' ? 'Issued State MX' : 'Estado de Emisión MX'}
  </label>
  <select
    className={`c-quote__select ${formik.touched.issuedStateMx && formik.errors.issuedStateMx ? 'js-form-error' : ''}`}
    id="issuedStateMx"
    name="issuedStateMx"
    required
    disabled={!isMexicanLicense}
    aria-required="true"
    aria-invalid={formik.touched.issuedStateMx && formik.errors.issuedStateMx ? 'true' : 'false'}
    onChange={(e) => {
      formik.handleChange(e);
    }}
    onBlur={formik.handleBlur}
    value={isMexicanLicense? formik.values.issuedStateMx : ""}
  >
    <option value="">
      {lang === 'eng' ? 'Select' : 'Seleccionar'}
    </option>
    <option value="AGU">Aguascalientes</option>
<option value="BCN">Baja California</option>
<option value="BCS">Baja California Sur</option>
<option value="CAM">Campeche</option>
<option value="CHP">Chiapas</option>
<option value="CHH">Chihuahua</option>
<option value="COA">Coahuila</option>
<option value="COL">Colima</option>
<option value="DUR">Durango</option>
<option value="GUA">Guanajuato</option>
<option value="GRO">Guerrero</option>
<option value="HID">Hidalgo</option>
<option value="JAL">Jalisco</option>
<option value="MEX">México</option>
<option value="MIC">Michoacán</option>
<option value="MOR">Morelos</option>
<option value="NAY">Nayarit</option>
<option value="NLE">Nuevo León</option>
<option value="OAX">Oaxaca</option>
<option value="PUE">Puebla</option>
<option value="QUE">Querétaro</option>
<option value="ROO">Quintana Roo</option>
<option value="SLP">San Luis Potosí</option>
<option value="SIN">Sinaloa</option>
<option value="SON">Sonora</option>
<option value="TAB">Tabasco</option>
<option value="TAM">Tamaulipas</option>
<option value="TLA">Tlaxcala</option>
<option value="VER">Veracruz</option>
<option value="YUC">Yucatán</option>
<option value="ZAC">Zacatecas</option>
  </select>
  {formik.touched.issuedStateMx && formik.errors.issuedStateMx ? (
    <label id="issuedStateMx-error" className="js-form-error" htmlFor="issuedStateMx">
      {formik.errors.issuedStateMx}
    </label>
  ) : null}
</div>

                  

<div className="c-quote__check">
  <input
    className="c-quote__check-input"
    id="checkbox"
    name="checkbox"
    type="checkbox"
    //check the box if if isforeigner is true, also caonole log isforeigner value
    checked={formik.values.is_foreigner === "YES"}


  
    onChange={(e) => {
      const isChecked = e.target.checked;
      const newIsForeignerValue = isChecked ? "YES" : "NO";
      
      // Set Formik values
      formik.setFieldValue("is_foreigner", newIsForeignerValue);
      formik.setFieldValue("issued_state_mx", ""); // Set issued_state_mx to blank

      setIsMexicanLicense(!isChecked);
    }}
  />
  <label className="c-quote__check-label" htmlFor="checkbox">
   {lang === 'eng'? " My license number is from outside Mexico." : "Mi número de licencia no es de México"}
  </label>



</div>
                  {/* Expiration Date */}
                  <div className={`c-quote__item c-quote__item--50 c-quote__item--m100 ${formik.touched.expirationDate && formik.errors.expirationDate ? 'c-quote-error' : ''}`}>
                    <label className="c-quote__label" htmlFor="expirationDate">
                      {lang === 'eng' ? 'Expiration Date‎ ‎ ‎ ‎ ‎ ‎ ‎ ' : 'Fecha de vencimiento‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ '}
                    </label>
                    <DatePicker
                      placeholderText={lang === 'eng' ? 'MM/DD/YYYY' : 'MM/DD/AAAA'}
                      className={`c-quote__input ${formik.values.expirationDate ? '' : 'c-quote__input--dob'} ${formik.touched.expirationDate && formik.errors.expirationDate ? 'js-form-error' : ''}`}
                      id="expirationDate"
                      name="expirationDate"
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      minDate={new Date()}
                      maxDate={new Date(new Date().setFullYear(new Date().getFullYear() + 8))}
                      selected={formik.values.expirationDate}
                      onChange={(date) => formik.setFieldValue("expirationDate", date)}
                      dateFormat="MM/dd/yyyy"
                      isClearable
                      customInput={
                        <MaskedInput
                          mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                          pipe={autoCorrectedDatePipe}
                          keepCharPositions
                        />
                      }
                      onBlur={(e) => e.target.readOnly = false}
                    />
                    {formik.touched.expirationDate && formik.errors.expirationDate ? (
                      <label id="expirationDate-error" className="js-form-error" htmlFor="expirationDate">
                        {formik.errors.expirationDate}
                      </label>
                    ) : null}
                  </div>

                  {
  !isMexicanLicense && ( // This will only render the component if isMexicanLicense is false
    <div className={`c-quote__item c-quote__item--d40 c-quote__item--m50 ${formik.touched.country_origin && formik.errors.country_origin ? 'c-quote-error' : ''}`}>
      <label className="c-quote__label" htmlFor="country_origin">
        {lang === 'eng' ? 'Country of Origin' : 'País de Origen'}
      </label>
      <input
        className={`c-quote__input ${formik.touched.country_origin && formik.errors.country_origin ? 'js-form-error' : ''}`}
        id="country_origin"
        type="text"
        name="country_origin"
        maxLength={50}
        required={false} // This field is not required, as it depends on the isMexicanLicense condition
        aria-required="false"
        aria-invalid={formik.touched.country_origin && formik.errors.country_origin ? 'true' : 'false'}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.country_origin}
      />
      {formik.touched.country_origin && formik.errors.country_origin && (
        <label id="country_origin-error" className="js-form-error" htmlFor="country_origin">
          {formik.errors.country_origin}
        </label>
      )}
    </div>
  )
}

                  {/*
              <div className="c-quote__item c-quote__item--50 c-quote__item--m100 c-quote__item c-quote__item--select">
              <label className="c-quote__label" htmlFor="">
                Select Year
              </label>
              <select className="c-quote__select" name="">
                <option value=""> </option>
                <option value={1}>1 </option>
                <option value={2}>2 </option>
                <option value={3}>3 </option>
              </select>
            </div>
            */}
                  <div className="c-quote__controls">
                    <button
                      className="c-quote__control c-quote__control--previous c-button c-button--linear-indingo"
                      type="button"
                      onClick={() => {
                        setIndexToNull();
                        backStep();
                    }}
                    >
                      {lang === 'eng' ? 'Discard' : 'Borrar'}
                    </button>
                    <button
                      className="c-quote__control c-quote__control--submit c-button c-button--blue-light"
                      type="submit"
                    >
                        {lang === 'eng' ? 'Save' : 'Guardar'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <footer className="c-site-footer">
    <div className="o-wrapper">
      <div className="c-site-footer__legal">
        <p className="c-site-footer__legal_text">
          © 2023 Bluefire Insurance Services Inc.
          <br />
          {lang === 'eng' ? <>List Of Entity/License Numbers Per State Located On  <br/></> : <>Listado de entidades/números de licencia por estado <br /> localizada en nuestra página de</>}  
  <a href="https://www.bluefireinsurance.com/affiliate-disclosure/" target="_blank" rel="noopener noreferrer">
    {lang === 'eng'? "Affiliate Disclosure Page." : " Aviso de Nuestras Filiales"} 
  </a>

        </p>
          <ul className="o-list-bare c-site-footer__legal_links">
  <li className="o-list-bare__item c-site-footer__legal-link">
    <a href="https://www.bluefireinsurance.com/privacy-policy/" target="_blank" rel="noopener noreferrer">
      { lang=== 'eng' ? ` Privacy Policy` : `Políticas de privacidad`}
    </a>
  </li>
  {window.innerWidth <= 768 && lang !== 'eng' ? (
    <>
      <li className="o-list-bare__item c-site-footer__legal-link">
        <a href="https://www.bluefireinsurance.com/california-consumer-privacy-policy/" target="_blank" rel="noopener noreferrer" style={{ whiteSpace: 'normal' }}>
          {lang === 'eng' ? "California Consumer Privacy Policy" : "Política de Privacidad del"}
        </a>
      </li>
      <li className="o-list-bare__item c-site-footer__legal-link spanish-consumer-link">
        <a href="https://www.bluefireinsurance.com/california-consumer-privacy-policy/" target="_blank" rel="noopener noreferrer" style={{ whiteSpace: 'normal' }}>
          {lang === 'eng' ? "" : "Consumidor de California"}
        </a>
      </li>
    </>
  ) : (
    <li className="o-list-bare__item c-site-footer__legal-link ">
      <a href="https://www.bluefireinsurance.com/california-consumer-privacy-policy/" target="_blank" rel="noopener noreferrer" style={{ whiteSpace: 'normal' }}>
        {lang === 'eng' ? "California Consumer Privacy Policy" : "Política de Privacidad del Consumidor de California"}
      </a>
    </li>
  )}
  <li className="o-list-bare__item c-site-footer__legal-link">
    <a href="https://www.bluefireinsurance.com/terms-of-use/" target="_blank" rel="noopener noreferrer">
      {lang === 'eng' ? " Terms of Use" : "Condiciones de uso"}
    </a>
  </li>
</ul>
      </div>
    </div>
  </footer>
      </>


    </>
  );
}


export default BfFormstep22;